<template>
    <v-card
            min-width="950"
            class="mt-2"
            elevation="0"
    >
        <v-toolbar-title>
            Autoplay Visualize Balance Graph
        </v-toolbar-title>
        <v-row>
            <v-col cols="auto" v-for="key in tgFilterFields" v-bind:key="key.key">
                <v-checkbox
                        :label='key.key'
                        v-model="key.select"
                        class="pa-0 ma-1"
                        @click="onTgChange"
                >
                </v-checkbox>
            </v-col>
        </v-row>
        <VisualizeChart :chartData="chartData" :chartOptions="chartOptions" />
        <v-range-slider
                v-model="levelRange"
                :max="20000"
                :min="1"
                :step="1"
                class="align-center"
                track-color="gray"
                color="red"
                hide-details
        >
            <template v-slot:prepend>
                <v-text-field
                        v-model="levelRange[0]"
                        density="compact"
                        style="width: 70px"
                        type="number"
                        variant="outlined"
                        hide-details
                        single-line
                        hint="level"
                ></v-text-field>
            </template>
            <template v-slot:append>
                <v-text-field
                        v-model="levelRange[1]"
                        density="compact"
                        style="width: 70px"
                        type="number"
                        variant="outlined"
                        hide-details
                        single-line
                ></v-text-field>
            </template>
        </v-range-slider>
        <v-container>
            <v-row align="center" justify="center">
                <v-col cols="auto">
                    <v-btn
                            @click="doApply"
                    >
                        Stages Load
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>

        <v-overlay :value="isLoading">
            <v-progress-circular
                    indeterminate
                    size="64"
            ></v-progress-circular>
        </v-overlay>
    </v-card>
</template>

<script>
    import VisualizeChart from './components/VisualizeChart.vue';
    import LevelSimulatorRefLoader from "./../../dao/LevelSimulatorRefLoader";

    export default {
        components: {
            VisualizeChart
        },
        data() {
            return {
                levelRange: [1, 1000],
                fullData: [],
                selectedFields: [],
                tgFilterFields: [],
                labelHints: {
                    timeToKillBoss: ["Time to Kill Boss", '#3b82f6'],
                    lvBestHeroStart: ["Lv Hero Begin", '#10b981'],
                    levelHeroWinBoss: ["Lv Hero vs Boss", '#ef4444'],
                    ghostFarming: ["Ghost Farm", '#ec4899'],
                    reviveBestHero: ["Revive Hero", '#6366f1'],
                    totalStageTime: ["Total Stage Time", '#f59e0b'],
                    //difficulty: ['Difficulty', '#f59e0b'],
                    lvHeroRemainCanBuy: ["Lv Hero can buy more", '#8b5cf6'],
                    heroBossFailed: ['Hero Field', '#7C0A02'],
                },

                chartOptions: {
                    responsive: true,
                    plugins: {
                        legend: { position: 'top' }
                    },
                    scales: {
                        y: { beginAtZero: true }
                    }
                },
                isLoading: false,
            };
        },
        methods:{
            async doApply(){
                this.isLoading = true;
                await this.loadData();
                this.isLoading = false;
            },

            async init(){
                this.isLoading = true;
                await this.loadData();
                this.extractAllFields(this.fullData);
                this.initFilter();
                this.refreshFilter();
                this.isLoading = false;
            },
            async loadData(){
                let levelStart = parseInt(this.levelRange[0]);
                let levelEnd = parseInt(this.levelRange[1]);
                this.fullData = await LevelSimulatorRefLoader.loadAutoplayStateByRange(levelStart, levelEnd);
                //this.defineDifficulty();
            },

            defineDifficulty(){
                this.fullData.forEach(entry => {
                    let score = 0;
                    score += entry['ghostFarming'] / 10;
                    score += entry['reviveBestHero'] * 2;
                    score += entry['reviveHeroPowerUp'] * 1.5;
                    score += entry['reviveBestSupport'] * 2;
                    score += entry['reviveBestPet'] * 1.5;
                    score += entry['heroBossFailed'] * 3;
                    score += entry['timeToKillBoss'] / 30;
                    score += entry['lvBetwenHeroNBoss'] > 3 ? (entry['lvBetwenHeroNBoss'] - 3) * 2 : 0;
                    entry.difficulty = score;
                });
            },

            initFilter(){
                this.tgFilterFields = [];
                this.selectedFields.forEach(key => {
                    this.tgFilterFields.push({
                        key,
                        select: key === "ghostFarming" || key === "lvHeroRemainCanBuy",
                    });
                });
            },

            refreshFilter(){
                this.selectedFields = this.tgFilterFields.filter(d => d.select).map((d) => d.key);
            },

            extractAllFields(data) {
                this.selectedFields = [];
                if(data.length > 0){
                    let entry = data[0];
                    Object.keys(entry).forEach((key) => {
                        if (key !== "_id" && key !== "stage" && typeof entry[key] === "number") {
                            if(this.labelHints[key]){
                                this.selectedFields.push(key);
                            }
                        }
                    });
                }
                if(this.selectedFields.length > 0){
                    this.selectedFields = this.selectedFields.sort();
                }
            },

            onTgChange() {
                this.refreshFilter();
            },

            getColor(index) {
                const colors = ['#3b82f6', '#f59e0b', '#10b981', '#ef4444', '#8b5cf6', '#14b8a6', '#ec4899', '#6366f1'];
                return colors[index % colors.length];
            }
        },
        computed: {
            chartData(){
                let index = this.selectedFields.length;
                return {
                    labels: this.fullData.map((d) => `Stage ${d.stage}`),
                    datasets: [...this.selectedFields].map((key) => ({
                        label: this.labelHints[key]?.[0] || key,
                        data: this.fullData.map((d) => parseFloat(d[key]) || 0),
                        borderColor: this.labelHints[key]?.[1] ||this.getColor(index),
                        backgroundColor: (this.labelHints[key]?.[1] || this.getColor(index++))+'44',
                        tension: 0.3
                    })),
                };
            },
        },
        created() {
            this.init();
        }
    };
</script>